import { createModalContext } from "shared/components/vero-modal";

export const {
  Context: MoreInfoDealModalContext,
  Provider: MoreInfoDealModalProvider,
  useModalContext: useMoreInfoDealModal,
} = createModalContext();
